<app-modal-header
  (close)="close()"
  [highlighted]="true">
  <span slot="breadcrumb">
    @if (operation === Operation.CREATE) {
      {{ 'admin.location-group-modal.breadcrumb.create' | translate }}
    }
    @if (operation === Operation.UPDATE) {
      {{ 'admin.location-group-modal.breadcrumb.update' | translate }}
    }
  </span>

  <div slot="title">
    <app-input-textarea-subtle [FC]="form.controls.title" [autoFocus]="operation === Operation.CREATE" [variant]="'light'" [placeholder]="'admin.location-group-modal.title-input.placeholder' | translate"></app-input-textarea-subtle>
  </div>
</app-modal-header>

<div class="modal-body">

  <div class="pt-3">

    <p-checkbox
      [formControl]="form.controls.external"
      [binary]="true"
      [label]="'admin.location-group-modal.external-input.label' | translate">
    </p-checkbox>


  </div>

</div>

<div class="modal-footer">
  <button
    (click)="close()"
    pButton
    label="{{'admin.location-group-modal.cancel-btn.label' | translate }}"
    class="p-button-sm p-button-plain p-button-text flex-1">
  </button>

  <button
    [loading]="saving"
    [disabled]="saving"
    (click)="onSubmit()"
    pButton
    label="{{'admin.location-group-modal.save-btn.label' | translate }}"
    class="p-button-sm flex-1">
  </button>
</div>